<template>
  <span class="info-tooltip" :data-position="dataPosition" :data-html="text">
    <i :class="iconClass"/>
  </span>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'info-tooltip',
    props: {
      text: {
        type: String,
        required: true
      },
      dataPosition: {
        type: String,
        default: "bottom center"
      },
      iconClass: {
        type: String,
        default: "fas fa-info-circle"
      }
    },
    mounted : function() {
      this.$nextTick(function () {
        if (window.$) {
          $('.info-tooltip').popup();
        }
      });
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/InfoTooltip.vue